import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";


export const getAuthorizationApprovalLetterUrl = (token, authHccId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/document/AuthApprovalLetter/Member/'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            AuthorizationHccId: authHccId
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetAuthorizationApprovalLetter", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetAuthorizationApprovalLetter", start, url, err); return Promise.reject(err);
    });
};

export const getBenefitDocuments = (token, planId, memId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/document/benefits/list'));
    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            benefitId: planId,
            memberId: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetBenefitDocuments", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetBenefitDocuments.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getBenefitDocument = (token, documentName) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/document/benefits/benefitDocument'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            documentName: documentName,
        })
    };

    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetBenefitDocument", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Benefits.GetBenefitDocument.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getDocumentsList = (token) => {
    //const url = encodeURI(`${webTpaApiUrl}/members/claims/list`); webTPA url
    let url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/document/importantdocs/'));
    //TODO-revisit after 9/1
    if (url.toLowerCase().includes("/ami/")) {
        url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/document/amisysimportantdocs/'));
        url = url.toLowerCase().replace("/ami/", "/hr/"); 
    }

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GettDocumentsList", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.text().then(function (text) {
                return text ? JSON.parse(text) : []
            }));
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetDocumentsList.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getDocumentDetails = (token, fileId) => {
    //const url = encodeURI(`${webTpaApiUrl}/members/claims/list`); webTPA url
    let url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/document/docfile/'));
    if (url.toLowerCase().includes("/ami/")) {
        url = url.toLowerCase().replace("/ami/", "/hr/");//TODO-revisit after 9/1
    }
    
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            FileId: fileId,
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GettDocumentDetails", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            //return Promise.resolve(response.status === 204 ? { status: 204, message: "No document was found" } : response.blob());
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetDocumentDetails.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getInvoicePDF = (token, MemberID, InvoiceNumber) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/document/invoice'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberID: MemberID,
            InvoiceNumber: InvoiceNumber
        })
    };

    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetDocumentInvoicePDF", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetDocumentInvoicePDF.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getIdCardPdf = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/members/documents/idcard'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId,
            format: "pdf" // Media Type
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.GetIdCard", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.GetIdCard.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getIdCardImage = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/members/documents/idcard'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: memId,
            format: "png" // Media Type
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.GetIdCardImage", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.GetIdCardImage.Failure", start, url, err); return Promise.reject(err);
    });
};

export const requestIdCard = (token, memId) => {
    const url = encodeURI( tools.buildUrl( tools.hpAPIBaseURL(), '/correspondence/idcard'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memberId: memId,
            reason: ""
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.RequestNewIdCard", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.IdCard.RequestNewIdCard.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getEobDocument = (token, memId, claimId) => {
    //const url = encodeURI(`${webTpaApiUrl}/members/documents/eob`);
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/members/documents/eob'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            claimid: claimId,
            memid: memId
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.Claims.GetEobDocument", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.status === 204 ? { status: 204, message: "No EOB was found" } : response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.Claims.GetEobDocument.Failure", start, url, err); return Promise.reject(err);
    });
}

export const getForm = (token, formName) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), '/document/forms'));

    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            documentName: formName,
        })
    };

    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetForm", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.Documents.GetForm.Failure", start, url, err); return Promise.reject(err);
    });
};